module.exports = {
  organizer: 'Organizer',
  home: 'Home',
  meeting: 'Meeting',
  agenda: 'Agenda',
  sponsorship_exhibitions: 'Sponsorship & Exhibitions',
  why_sponsor: 'Why sponsor',
  sponsorship_consulting: 'Consulting',
  why_sponsor_text1: 'iTall is a high-end business social brand focusing on the development and innovation of science and technology in China and the Asia-Pacific region. Through a series of summits and exhibitions, iTall has continued to influence and empower many organizations including consumer, pharmaceutical, manufacturing, financial and other industries, deeply connecting the middle and lower reaches of the industry chain, reshaping the business process with science and technology, improving the efficiency of business operations, and driving long-term development of enterprises.',
  why_sponsor_text2: "We take practical project supply and demand, real-time case analysis, precise decision-making communication, and substantive project cooperation promotion as the core, and take the current hot and rich topics as the traction, embedded in the industry's key areas and key links, empowering institutions and their decision-making teams, and promoting industrial technological change and optimization and upgrading.",
  sponsors_exhibitors: 'Sponsors & Exhibitors',
  awards: 'Awards',
  enroll: 'Enroll',
  conference_pass: 'Conference pass',
  early_bird_tickets: 'Special early bird tickets',
  free_tickets: 'Free tickets',
  CSTIS: 'China Science and Technology Innovation Summit',
  CSTIS_text: 'Seize the highest point of scientific and technological innovation',
  learn_more: 'Learn more',
  num1: 'Delegates',
  num2: 'Sponsors & Exhibitors',
  num3: 'Guest speakers',
  num4: 'Time',
  num5: 'Special',
  itall: 'iTaLL Science and innovation',
  itall_text1: "Under the wave of digitalization, science and technology innovation has become the core driving force of the new round of industrial change, and new technologies are constantly broadening industrial boundaries and accelerating industrial upgrading and transformation. iTall China Science and Innovation Summit will be held by Huiyao Group in Shanghai on November 23, and the summit will focus on three special sessions on financial science and technology, intelligent manufacturing, and the future of pharmaceuticals, so as to discuss ways to accelerate the digital transformation of the industry, and to find a way to break through under the changing circumstances. The summit will be organized by iTall Group in Shanghai.",
  itall_text2: "We take real-time case analysis, practical project supply and demand, precise decision-making communication and substantive cooperation promotion as the core, and take the current hot and rich topics as the traction, embedded in the industry's key areas and key links, empowering institutions and their decision-making teams, and promoting industrial technological change and optimization and upgrading.",
  guest_speakers: 'Guest speakers',
  guest_speakers_text: 'Some of the speakers in previous editions are ranked in no particular order',
  guest_speakers_text2: "This year's speakers, in no particular order",
  guest1: 'Hu Wei',
  guest1_text1: 'Assistant General Manager of Information Planning Department',
  guest1_text2: 'Taikang Pension Insurance Co., Ltd',
  guest2: 'Lin Jian',
  guest2_text1: 'Vice President of Datacom/General Manager of Financial Business Unit',
  guest2_text2: 'Kehua Data',
  guest3: 'Zhao Xujie',
  guest3_text1: 'Deputy General Manager of Strategic Development Department/China Reinsurance Research Institute',
  guest3_text2: 'Zhongzai Group',
  guest4: 'Cai Jianhong',
  guest4_text1: 'Greater China Leader',
  guest4_text2: 'RNA ANALYTICS',
  guest5: 'Yao Kai',
  guest5_text1: 'Director of Operations',
  guest5_text2: 'Hongkang Life',
  guest6: 'Guo Shaowei',
  guest6_text1: 'Chief Actuary, Chief Risk Officer',
  guest6_text2: 'Huiyou Property Mutual Insurance Co., Ltd',
  guest7: 'Chen Jing',
  guest7_text1: 'General Manager of Information Technology Department',
  guest7_text2: 'Sumitomo Mitsui Marine Fire Insurance',
  guest8: 'Zhang Ning',
  guest8_text1: 'Doctoral supervisor and professor',
  guest8_text2: 'Head of Financial Technology Major, School of Finance, Central University of Finance and Economics',
  guest9: 'Lu Shuyu',
  guest9_text1: 'General Manager of Technical Support Center',
  guest9_text2: 'Sanwei Xinan Technology Co., Ltd',
  guest10: 'Wang Ke',
  guest10_text1: 'Marketing Director',
  guest10_text2: 'Sanwei Xinan Technology Co., Ltd',
  guest11: 'Fang Chao',
  guest11_text1: 'Deputy General Manager',
  guest11_text2: 'Love Life Insurance',
  guest12: 'Chen Qiuyi',
  guest12_text1: 'Operations Specialist',
  guest12_text2: 'Cindat Life',
  guest13: 'Zhang Shuguo',
  guest13_text1: 'CIO',
  guest13_text2: 'China Coal Property Insurance',
  guest14: 'Zhang Jie',
  guest14_text1: 'General Manager, Data Division',
  guest14_text2: 'Modern property insurance',
  guest15: 'Ren Qi',
  guest15_text1: 'Senior Vice President',
  guest15_text2: 'Kirin Shinan',
  guest16: 'Cui Nan',
  guest16_text1: 'Executive Director, Greater China',
  guest16_text2: 'Frost & Sullivan',
  guest17: 'White Snow Peak',
  guest17_text1: 'CTO',
  guest17_text2: 'Saxo Financial Technology Limited',
  guest18: 'Chen Weili',
  guest18_text1: 'General Manager of Scene Ecology Department of Open Banking Department',
  guest18_text2: 'Centaline Bank',
  guest19: 'Zou Qi',
  guest19_text1: 'General Manager of Innovative Finance Department',
  guest19_text2: 'Liaoning Zhenxing Bank',
  guest20: 'Zhang heng',
  guest20_text1: 'Director of Solutions',
  guest20_text2: 'Netsu Technology',
  guest21: 'Wang Wei',
  guest21_text1: 'General Manager, Financial Services',
  guest21_text2: 'Century Connect',
  guest22: 'Lin tao',
  guest22_text1: 'founder&CEO',
  guest22_text2: 'Estimation Section',
  guest23: 'Yang Jianfei',
  guest23_text1: 'Deputy General Manager of Beijing Software Development Center',
  guest23_text2: 'Blue Ocean Bank',
  guest24: 'Chen Siqi',
  guest24_text1: 'Global Payment Solutions Department Industry and Commerce',
  guest24_text2: 'Director of Financial Sales, HSBC',
  guest25: 'Zhao Guohao',
  guest25_text1: 'Vice President of Financial Services Solutions',
  guest25_text2: 'Light rain point math section',
  guest26: 'Zhang Xufeng',
  guest26_text1: 'General Manager of Digital Finance Department',
  guest26_text2: 'Zhejiang Chouzhou Commercial Bank',
  guest27: 'Lu Yuan',
  guest27_text1: 'Executive Vice President',
  guest27_text2: 'Digital Yan Group',
  guest28: 'Lin Yongfeng',
  guest28_text1: 'General Manager of Shanzheng Technology',
  guest28_text2: 'Shanxi Securities',
  guest29: 'Wang Jianhui',
  guest29_text1: 'Research Director, Investment Manager',
  guest29_text2: 'Dongxing Securities Co., Ltd., asset management business headquarters',
  guest30: 'Yang Tao',
  guest30_text1: 'Co-founder&CEO',
  guest30_text2: 'Vantai Geek',
  guest31: 'Peng Jun',
  guest31_text1: 'Vice President',
  guest31_text2: 'Bohao Data Services Co., Ltd',
  guest32: 'Xu Zhuohan',
  guest32_text1: 'Senior Account Manager',
  guest32_text2: 'Beijing Yonghong Business Intelligence Technology Co.',
  guest33: 'Mo Zuo',
  guest33_text1: 'Vice President',
  guest33_text2: 'Beijing Shangyue Network Technology Co., Ltd',
  guest34: 'Tang Zhiyong',
  guest34_text1: 'President, Chief Consultant',
  guest34_text2: 'Blue Cloud Software',
  sponsors: "Sponsors",
  title1: 'Speech sponsor',
  title2: 'Collaborative sponsors',
  title3: 'Exhibitor sponsor',
  sponsors_text: 'Some sponsors in the past, in no particular order',
  conference_highlights: 'Conference highlights',
  participating_businesses: 'Participating businesses',
  institution: 'institution',
  trust_in_us: 'Trust in us',
  footer1: 'Sponsorship & Exhibitions',
  footer2: 'Presentations and free attendance',
  time: 'working hours',
  why_talk: 'Invitation to the stage',
  why_talk_text: "The iTall China Summit Series sincerely welcomes industry experts to join as keynote speakers, roundtable discussants or moderators. If you are interested in joining this high-end science and technology social circle, please fill out the following application form, subject to the iTall organizing committee's review results, the review is generally within one to two working days.",
  request: 'request',
  speech_item1: 'Closed Door Case Study Demonstration',
  speech_item2: 'Partner Engagement Interaction',
  speech_item3: 'Radiation-driven capacity enhancement',
  speech_item4: 'Expanding High-Level Networks',
  speech_item5: 'Accelerated strategic deployment',
  speech_item6: 'Improve market layout',
  day1: '2July 27, 2023 Day 1',
  day1_1: 'Localization',
  day1_2: 'Opening remarks',
  day1_3: 'In line with the policy orientation of the digital economy, localization is coming to the wave',
  day1_4: "Keynote Speech: Riding the Momentum to Accelerate Banks' ESG and Green Finance Transformation Practices",
  day1_5: 'Keynote Speech: Take scientific and technological innovation services as the first hand and create a new model of closed-loop services',
  day1_6: 'Morning coffee break, booth visit, technology show, interactive communication',
  day1_7: 'Keynote: CBDC, a payment that goes beyond bank integration',
  day1_8: 'Keynote Speech: How can banks leverage their advantages through digital and online service models to practice green and sustainable development',
  day1_9: 'Brainstorming: Digital intelligence leads and discusses the new pattern of financial science and technology development',
  day1_10: 'Lunchtime',
  day1_11: 'internationalization',
  day1_12: 'Keynote Speech: Driven by Digital, Create a Win-Win Development Path for Traditional Banks and Virtual Banks',
  day1_13: 'Keynote Speech: How Financial Institutions Promote the Application of Metaverse in Scenario Finance',
  day1_14: 'Keynote: How to create competitive advantage by developing a robust and seamless data ecosystem',
  day1_15: 'Sponsorship opportunities',
  day1_16: 'Keynote: AI Stan? The next Einstein of humanity',
  day1_17: 'Sponsorship opportunities',
  day1_18: 'Afternoon coffee break and interactive communication',
  day1_19: 'Tech show',
  day1_20: 'Roundtable discussion',
  day1_21: 'Closing',
  day2: 'July 28, 2023 Day 2',
  day2_1: 'Banking power',
  day2_2: 'Opening remarks',
  day2_3: 'Explore digital operation transformation and lead the high-quality development of banks',
  day2_4: 'Difficulties and strategies for digital transformation of commercial banks',
  day2_5: 'Sponsorship opportunities',
  day2_6: 'Morning coffee break, booth visit, technology show, interactive communication',
  day2_7: 'Insurance power',
  day2_8: 'Keynote Speech: Intelligent risk control and business integration of digital insurance bring greater benefits',
  day2_9: "Discuss the impact of insurance accounting standards and regulatory rules on the future of China's insurance market",
  day2_10: 'Keynote (RNA Analytics Booked)',
  day2_11: 'Brainstorming: The insurance industry is about to change, the future direction of financial risk management and actuarial work?',
  day2_12: 'Lunchtime',
  day2_13: 'Financial practice',
  day2_14: 'Keynote Speech: Securing the Secure Foundation for Digital Transformation – Promoting Zero Trust Implementation',
  day2_15: 'Keynote speech: The path and method of building a digital operation service system',
  day2_16: 'Keynote Speech: With the Strong Rise of Distributed Databases, How Should Domestic Small and Medium-sized Financial Institutions Choose?',
  day2_17: 'Sponsorship opportunities',
  day2_18: 'Keynote Speech: Cloud empowerment drives product form, industrial format and business model innovation at the application level',
  day2_19: 'Sponsorship opportunities',
  day2_20: 'Afternoon coffee break and interactive communication',
  day2_21: 'Financial innovation',
  day2_22: 'Tech show',
  day2_23: 'Roundtable discussion: Building a new situation of trusted, secure and stable fintech',
  day2_24: 'The meeting is closed',
  rights: 'iTall sponsorship benefits include:',
  rights1: 'Closed-door high-level meetings',
  rights2: 'Closed-door project exchanges',
  rights3: 'Keynote Sharing',
  rights4: 'Round-table discussions',
  rights5: 'All-round publicity and promotion of the General Assembly',
  rights6: 'Targeted Invitation to Intended Customers',
  rights7: 'One-on-one business referrals',
  will_get: 'You will get',
  get1: 'Promote new technologies and new cases',
  get2: 'Attract new customers, new cooperation',
  get3: 'Increase brand awareness and influence',
  get4: "Expand your prospects' network at the top",
  get5: 'Accelerate market expansion and customer conversion',
  get6: 'Consolidate industry position and market share',
  include: 'Sponsorship opportunities include:',
  include1: 'The upper floors are closed',
  include2: 'Keynote',
  include3: 'Roundtable discussion',
  include4: 'Booth display',
  include5: 'Tech show',
  include6: 'Advertising',
  sponsors1: 'Founded in Shenzhen in 2007, Xiaoyudian is a pioneer in the field of big data analysis and application in China. Adhering to the vision of "discovering the truth of data and releasing the vitality of data", Xiaoyudian transforms practical problems into mathematical application problems through research on advanced technologies such as big data, artificial intelligence, and blockchain, and creates an industry-level big data application system, which can provide enterprises with whole-process solutions covering decision-making strategies, intelligent management, intelligent analysis, risk control and so on. After more than ten years of development, Xiaoyudian has served domestic and foreign commercial banks, insurance, securities, consumer finance and other financial institutions, as well as leading enterprises in telecommunications, retail, logistics, medical and other industries.',
  sponsors2: 'Started in 2019, Estimating Digital Technology focuses on inclusive finance, supply chain finance, and green finance, focusing on risk control and marketing scenarios, providing financial institutions with SaaS products, API services and business core systems for small and medium-sized enterprises. The goal is to become a compliant, credible and efficient technology partner of financial institutions. Smart has been formed.',
  sponsors3: "Shangyue Technology is an intelligent company that provides digital panoramic solutions for procurement for large and medium-sized enterprises, and helps each customer build an exclusive procurement Internet platform through Shangyue's intelligent procurement middle platform, SaaS application and operation services, so that the whole process of enterprise procurement is online, digital and intelligent, improving efficiency and reducing costs.",
  sponsors4: 'Hunan Kirin Xinan Technology Co., Ltd. (stock code: 688152) is the supporting entity of the National and Local Joint Engineering Research Center for Highly Trusted Operating Systems approved by the National Development and Reform Commission, and has been selected as a national "specialized, specialized and new" small giant enterprise and a key software enterprise in the national planning layout, and is committed to promoting localized security applications.',
  sponsors5: "INTSIG is an artificial intelligence and big data technology enterprise, based on the leading intelligent text recognition and business big data core technologies independently developed, the company's C-end business is mainly for global C-end users and B-end customers in multiple industries to provide digital and intelligent products and services, the company's C-end business is mainly APP products for global individual users, including CamCard (intelligent scanning and text recognition APP), Business Card CamMan (smart business card and network management APP), Qixinbao (enterprise business information query APP) 3 core products; The company's B-end business provides enterprise customers with intelligent text recognition and business big data as the core services, forming a business matrix including basic technical services, standardized services and scenario-based solutions, meeting the diversified needs of customers such as cost reduction and efficiency improvement, risk management, and intelligent marketing, and helping customers achieve digital and intelligent transformation and upgrading. With leading independent research and development technology, mature product landing capabilities, high-quality user experience and service quality, the company's C-end products cover hundreds of millions of users in more than 100 countries and regions around the world, and B-end services cover enterprise customers in nearly 30 industries. In terms of B-end business, the company's intelligent text recognition and business big data services have covered many head customers in nearly 30 industries such as banking, securities, insurance, government, logistics, manufacturing, real estate, and retail, and the company's customers have covered more than 80 of the world's top 500 companies released by Fortune magazine in 2020.",
  sponsors6: 'Guangzhou Smart Software Co., Ltd. (hereinafter referred to as Smart Software) was established in 2011, is committed to providing one-stop business intelligence solutions for enterprise customers, with the mission of enhancing and mining the data value of enterprise customers, focusing on business intelligence (B) and big data analysis software products and services. Smartbi is a one-stop big data analysis platform that has been continuously developed for many years, integrating data analysis and decision support in various industries. Meet the needs of end users in big data analysis such as enterprise-level reports, data visualization analysis, self-service exploration and analysis, data mining modeling, and A! intelligent analysis. At the same time, as a purely domestic business intelligence and big data analysis product, Smartbi has better design flexibility and adaptability for the local needs of domestic users on the basis of maintaining competitiveness with international products of the same level.',
  person: 'person',
  price: "October 30th resumed 6800/seat",
  ticket1: 'Admission is free',
  ticket2: '0 per seat',
  ticket3: 'Registration is free',
  ticket4: 'Until October 30th only',
  ticket5: '1-day session',
  ticket6: 'Tech Show Visit',
  ticket7: 'Exhibition area visit',
  ticket8: 'Coffee break communication',
  ticket9: 'Free registration with check-in access',
  ticket10: 'Electronic Conference Journal',
  ticket11: 'Five-star buffet luncheon',
  ticket12: 'simultaneous interpretation',
  ticket13: 'Arranged according to the actual situation of the General Assembly',
  ticket14: 'The full set of PPT can be published after the meeting',
  ticket15: 'One-on-one business referrals',
  ticket16: 'high-level closed-door exchange',
  ticket17: 'SVIP exclusive communication group',
  ticket18: 'Post-meeting referrals',
  ticket2_1: 'VIP delegates',
  ticket2_2: '0 per seat (Finance/Pharmaceutical/Manufacturing/A business decision makers only)',
  ticket2_3: '3,000￥/person',
  ticket2_4: 'Sign up now',
  ticket2_5: 'The original price will be restored on July 1',
  ticket2_6: 'Original price resumed on October 30th',
  ticket2_7: 'Exhibition area visit',
  ticket2_8: 'Coffee break communication',
  ticket2_9: 'Exclusive registration and check-in channels',
  ticket2_10: 'Paper conference journal',
  ticket2_11: 'Coffee break pastries',
  ticket2_12: 'Exclusive conference badge',
  ticket2_13: 'Exclusive seats and seats',
  ticket2_14: 'Exclusive conference badge',
  ticket2_15: 'Five-star independent luncheon',
  ticket2_16: 'simultaneous interpretation',
  ticket2_17: 'The full set of PPT can be published after the meeting',
  ticket2_18: 'Arranged according to the actual situation of the General Assembly',
  ticket2_19: 'One-on-one business referrals',
  ticket2_20: 'Closed-door communication at the top',
  ticket2_21: 'SVIP exclusive communication group',
  ticket2_22: 'Post-meeting referrals',
  ticket3_1: 'SVIP guests',
  ticket3_2: '3,000￥/person',
  ticket3_3: '6,800￥/person',
  ticket3_4: 'Sign up now',
  ticket3_5: 'Original price resumed on October 30th',
  ticket3_6: '2-day session',
  ticket3_7: 'Exhibition area visit',
  ticket3_8: 'Coffee break communication',
  ticket3_9: 'Exclusive registration and check-in channels',
  ticket3_10: 'Paper conference journal',
  ticket3_11: 'Coffee break pastries',
  ticket3_12: 'Exclusive conference badge',
  ticket3_13: 'Exclusive seats and seats',
  ticket3_14: 'Exclusive conference badge',
  ticket3_15: 'Five elements buffet luncheon',
  ticket3_16: 'simultaneous interpretation',
  ticket3_17: 'The full set of PPT can be published after the meeting',
  ticket3_18: 'Arranged according to the actual situation of the General Assembly',
  ticket3_19: 'One-on-one business referrals',
  ticket3_20: 'Closed-door communication at the top',
  ticket3_21: 'SVIP exclusive communication group',
  ticket3_22: 'Post-meeting referrals',
  expired: 'Expired',
  guestnow1_1: 'Chang Liang',
  guestnow1_2: 'General Manager of Technology and Innovation Department',
  guestnow1_3: 'CITIC Insurance',
  guestnow2_1: 'Xu Qian',
  guestnow2_2: 'Business Development Manager',
  guestnow2_3: 'Tokyo Marine & Nichido Fire Insurance (China) Co.',
  guestnow3_1: 'Rui Gao',
  guestnow3_2: 'Software development center test board board master',
  guestnow3_3: 'China CITIC Bank',
  guestnow4_1: 'Xu List',
  guestnow4_2: 'General Manager of Financial Markets Department',
  guestnow4_3: 'Huabao Duding (Shanghai) Financial Leasing Co.',
  guestnow5_1: 'Jiang Xufeng',
  guestnow5_2: 'General Manager of Retail Finance Department',
  guestnow5_3: 'Wing Fung Bank',
  guestnow6_1: 'Li Feng',
  guestnow6_2: 'Head of Fintech Research Institute',
  guestnow6_3: 'Societe Generale',
  guestnow7_1: 'Wang Yingjie',
  guestnow7_2: 'Database Department Director',
  guestnow7_3: 'Lufthansa Holdings',
  guestnow8_1: 'Yang Xiaocheng',
  guestnow8_2: 'Partner',
  guestnow8_3: 'Frost & Sullivan',
  guestnow9_1: 'Shang Zhenyang',
  guestnow9_2: 'General Manager of Digital Intelligence Transformation Office',
  guestnow9_3: 'Centaline Bank',
  guestnow10_1: 'Wang Haiping',
  guestnow10_2: 'Vice President',
  guestnow10_3: 'Cinda Futures',
  guestnow11_1: 'Wang Minghong',
  guestnow11_2: 'Director of FICC Business Development Line, Information Technology Department',
  guestnow11_3: 'Huaxi Securities',
  guestnow12_1: 'Wang Qunhang',
  guestnow12_2: 'Director, Vice President',
  guestnow12_3: 'Bacardi Fund',
  guestnow13_1: 'Yang Guang',
  guestnow13_2: 'Chief Information Officer and Chief Marketing Officer',
  guestnow13_3: 'CNA',
  guestnow14_1: 'Zhao Yan',
  guestnow14_2: 'Vice President',
  guestnow14_3: 'State China Life',
}